import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import { Input, Measurement } from "../../../../form-inputs/inputs";
import { AsyncTypeahead, Typeahead } from "../../../../form-inputs/typeahead";

//TODO: Convert to SFC?
class Ingredient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.data,
        };
    }

    updateField = (key, value) => {
        this.setState({
            [key]: value,
        });

        this.props.updateOnChange({
            ...this.state,
            [key]: value,
        });
    };

    removeItem = () => {
        this.props.removeItem("activeIngredients", this.state.key);
        document.getElementsByName("newIngredient")[0].focus();
    };

    render() {
        return (
            <div className="input-group">
                <Typeahead
                    label="Mark"
                    name="noteMark"
                    id={`noteMark_${this.state.key}`}
                    defaultValue={this.state.noteMark}
                    options={this.props.noteMarkList}
                    updateOnChange={this.updateField}
                    className="-x-small"
                />
                <AsyncTypeahead
                    label="Ingredient"
                    id={`ingredient_${this.state.key}`}
                    name="name"
                    defaultValue={this.state.name}
                    provider="/picklists/drugActiveIngredients"
                    creatable={true}
                    updateOnChange={this.updateField}
                />
                <Measurement
                    label="Value"
                    name="measurement"
                    id={`measurement_${this.state.key}`}
                    defaultValue={this.state.measurement}
                    filter={["mass"]}
                    updateOnChange={this.updateField}
                />
                <Input label="Purpose" name="purpose" id={`purpose_${this.state.key}`} value={this.state.purpose} updateOnChange={this.updateField} />
                <button className="button -primary -small" onClick={this.removeItem}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </button>
            </div>
        );
    }
}

export default Ingredient;
